export default "__VITE_ASSET__CHgLvCOb__"